import ShowWinState from '../../../vendor_core/core/src/states/ShowWinState';
import BetModel from '../../core/src/model/BetModel';
import SpinModel from '../../core/src/model/SpinModel';

export default class VendorShowWinState extends ShowWinState {
    protected get haveBangup(): boolean {
        return SpinModel.getCurrentWin() >= (3 * BetModel.totalBet);
    }
}